import { DriveModesTableMarkdownItem } from './drive-modes-table-markdown-item.js';
import { JsonBodyRemarkPlugin } from './markdown-plugins-utils.js';

import type { RemarkMarkdownDirectiveDefinition } from './markdown-plugins-utils.js';

/** Directive name used in markdown container blocks: `:::drive-modes-table` */
export const DRIVE_MODES_TABLE_DIRECTIVE = 'drive-modes-table';

/**
 * Remark plugin definition for the `drive-modes-table` container directive.
 *
 * Usage in markdown:
 * ```
 * :::drive-modes-table
 * [JSON array]
 * :::
 * ```
 *
 * The directive body is parsed as JSON and passed to {@link DriveModesTableMarkdownItem}
 * via the `jsonData` prop.
 */
export const driveModesTableDirectiveDefinition: RemarkMarkdownDirectiveDefinition = {
	allowedAttributes: ['jsonData'],
	directive: JsonBodyRemarkPlugin(DRIVE_MODES_TABLE_DIRECTIVE),
	item: DriveModesTableMarkdownItem,
};
